import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ReportRecipient, ScheduleEmailParams } from '@app/interfaces/lm/report-schedules';
import { RecipientsTableComponent } from '@app/shared/components/recipients-table/recipients-table.component';
import { ReportSchedulesService } from '@services/lm/report-schedules.service';
import { ReportingService } from '@services/lm/reporting.service';
import { TokenService } from '@services/sys/token.service';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-schedule-setting',
    templateUrl: './schedule-setting.component.html',
    styleUrls: ['./schedule-setting.component.less'],
})
export class ScheduleSettingComponent implements OnInit {
    @ViewChild('recipientsTable') recipientsTable!: RecipientsTableComponent;
    @Input() type = 'project-group';
    @Input() currentUser!: ReportRecipient;
    isVisible = false;
    submitLoading = false;
    enable = false;
    time: any;
    loading = false;
    checkOptions = [
        { label: 'Mon', value: 'MONDAY', checked: false },
        { label: 'Tue', value: 'TUESDAY', checked: false },
        { label: 'Wed', value: 'WEDNESDAY', checked: false },
        { label: 'Thu', value: 'THURSDAY', checked: false },
        { label: 'Fri', value: 'FRIDAY', checked: false },
        { label: 'Sat', value: 'SATURDAY', checked: false },
        { label: 'Sun', value: 'SUNDAY', checked: false },
    ];
    checkOptionsOne: {
        label: string;
        value: string;
        checked: boolean;
    }[] = [];
    id!: string;
    repeatType = 'Daily';
    selectUserEmails: string[] = [];

    constructor(private reportSchedulesService: ReportSchedulesService,
                private reportingService: ReportingService,
                private tokenService: TokenService,
                private message: NzMessageService) {
    }

    ngOnInit(): void {
    }

    async open(id: string): Promise<void> {
        try {
            dayjs.extend(utc);
            dayjs.extend(timezone);
            this.id = id;
            this.loading = true;
            this.isVisible = true;
            this.reset();
            this.selectUserEmails = [this.currentUser.email];
            const editData = this.type === 'project' ? await this.reportSchedulesService.getProjectReportSchedule({ projectId: id }) :
                await this.reportSchedulesService.getProjectGroupReportSchedule({ projectGroupId: id });
            if (editData) {
                const { enable, time, repeat, timeZone, recipients } = editData;
                this.enable = enable;
                const today = dayjs(new Date()).format('YYYY-MM-DD');
                this.time = time ? dayjs(today + ' ' + time).tz(timeZone) : new Date();
                const arr = repeat ? repeat.split(',') : [];
                this.repeatType = arr.length === 7 ? 'Daily' : 'Weekly';
                this.selectUserEmails = recipients && recipients.length > 0 ? recipients : [this.currentUser.email];
                if (this.repeatType === 'Weekly') {
                    this.checkOptionsOne = this.checkOptions.map((item) => {
                        return {
                            ...item,
                            checked: arr.includes(item.value),
                        };
                    });
                }
            }
        } finally {
            this.loading = false;
        }
    }

    reset(): void {
        this.repeatType = '';
        this.enable = false;
        this.time = new Date();
        this.checkOptionsOne = JSON.parse(JSON.stringify(this.checkOptions));
    }

    close(): void {
        this.isVisible = false;
    }

    DayHasChecked(): {
        label: string,
        value: string,
        checked: boolean
    }[] {
        const arr = this.checkOptionsOne.filter((item) => item.checked);
        return arr;
    }

    async submit(): Promise<void> {
        try {
            if (!this.id) {
                return ;
            }
            const arr = this.repeatType === 'Daily' ? this.checkOptions : this.DayHasChecked();
            if (!this.time || arr.length <= 0) {
                this.message.warning('Please Select Repeat');
            }
            if (!this.recipientsTable.validForm()) {
                return ;
            }
            const recipients = this.recipientsTable.getParams();
            this.submitLoading = true;
            const commonParams: ScheduleEmailParams = {
                enable: this.enable,
                time: dayjs(this.time).format('HH:mm'),
                timeZone: dayjs.tz.guess(),
                repeat: arr.map((item) => item.value).join(','),
                recipients
            };
            this.type === 'project' ? await this.reportSchedulesService.addProjectReportSchedule({
                    ...commonParams,
                    projectId: this.id,
                }) :
                await this.reportSchedulesService.addProjectGroupReportSchedule({
                    ...commonParams,
                    projectGroupId: this.id,
                });
            this.message.success('Report Email Scheduled Successfully');
            this.close();
        } finally {
            this.submitLoading = false;
        }
    }
}
